import type {ReactNode} from 'react'
import {useRuntimeEnvironment} from '@github-ui/ssr-utils/use-runtime-environment'

interface ClientOnlyProps {
  /** Content to render on the client */
  children: ReactNode
  /** Optional fallback to render on the server (defaults to null) */
  serverFallback?: ReactNode
}

/**
 * Wrapper component that only renders children on the client to avoid
 * Suspense issues with renderToString during SSR.
 */
export function ClientOnly({children, serverFallback = null}: ClientOnlyProps) {
  const {isServer} = useRuntimeEnvironment()

  if (isServer) return <>{serverFallback}</>

  return <>{children}</>
}
